(function(){
  'use strict';
  function setupCarousel(container){
    if(container.dataset.mpNativeReady==='true') return;
    var controlsScope=container.closest('.ecom-slider--container, .ecom-collection__product-container, .ecom-testimonials--container')||container;
    container.classList.add('ecom-swiper-initialized','ecom-swiper-horizontal','ecom-swiper-container-initialized');
    controlsScope.classList.add('ecom-swiper-initialized-wrapper');
    var wrapper=container.querySelector('.ecom-swiper-wrapper');
    if(!wrapper){
      container.style.opacity='1';container.style.visibility='visible';
      controlsScope.style.opacity='1';controlsScope.style.visibility='visible';
      return;
    }
    var slides=Array.prototype.slice.call(wrapper.children).filter(function(el){return el.classList.contains('ecom-swiper-slide');});
    if(slides.length<2){
      container.style.opacity='1';container.style.visibility='visible';
      wrapper.style.opacity='1';wrapper.style.visibility='visible';
      controlsScope.style.opacity='1';controlsScope.style.visibility='visible';
      slides.forEach(function(slide){slide.style.opacity='1';slide.style.visibility='visible';});
      return;
    }
    container.dataset.mpNativeReady='true';
    var index=0, perView=1, timer=null;
    controlsScope.dataset.mpNativeCarouselRoot='true';
    var prev=controlsScope.querySelector('.ecom-swiper-button-prev');
    var next=controlsScope.querySelector('.ecom-swiper-button-next');
    var pagination=controlsScope.querySelector('.ecom-swiper-pagination');
    function columns(){
      var width=window.innerWidth;
      var attr=width<768?'data-grid-column-mobile':(width<1025?'data-grid-column-tablet':'data-grid-column');
      var value=parseInt(wrapper.getAttribute(attr)||'1',10);
      return isFinite(value)&&value>0?Math.min(value,slides.length):1;
    }
    function maxIndex(){return Math.max(0,slides.length-perView)}
    function render(){
      perView=columns();
      index=Math.min(index,maxIndex());
      container.style.setProperty('--mp-slides-per-view',String(perView));
      wrapper.style.transform='translate3d('+(-index*(100/perView))+'%,0,0)';
      if(prev) prev.disabled=index<=0;
      if(next) next.disabled=index>=maxIndex();
      if(pagination){
        Array.prototype.forEach.call(pagination.querySelectorAll('button[data-mp-slide]'),function(dot,n){
          dot.setAttribute('aria-current',n===index?'true':'false');
        });
      }
    }
    if(pagination){
      pagination.innerHTML='';
      for(var n=0;n<=maxIndex();n+=1){
        var dot=document.createElement('button');
        dot.type='button';
        dot.dataset.mpSlide=String(n);
        dot.setAttribute('aria-label','Folie '+(n+1));
        dot.addEventListener('click',function(event){index=parseInt(event.currentTarget.dataset.mpSlide,10)||0;render();});
        pagination.appendChild(dot);
      }
    }
    if(prev) prev.addEventListener('click',function(){index=Math.max(0,index-1);render();});
    if(next) next.addEventListener('click',function(){index=Math.min(maxIndex(),index+1);render();});
    window.addEventListener('resize',render,{passive:true});
    render();
    var raw=container.getAttribute('data-option-swiper');
    if(raw){
      try{
        var options=JSON.parse(raw);
        if(options.autoplay&&options.autoplay.enabled&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
          var delay=Math.max(2000,parseInt(options.autoplay.delay,10)||6000);
          timer=window.setInterval(function(){index=index>=maxIndex()?0:index+1;render();},delay);
          container.addEventListener('mouseenter',function(){if(timer){clearInterval(timer);timer=null;}},{once:true});
        }
      }catch(error){}
    }
  }
  function setupTabs(scope){
    Array.prototype.forEach.call((scope||document).querySelectorAll('.tabs__wrapper'),function(group){
      if(group.dataset.mpTabsReady==='true') return;
      var tabs=Array.prototype.slice.call(group.querySelectorAll('.tabs__nav[data-target-id]'));
      if(!tabs.length) return;
      group.dataset.mpTabsReady='true';
      var panels=tabs.map(function(tab){return group.querySelector(tab.getAttribute('data-target-id'));});
      function activate(index,focus){
        tabs.forEach(function(tab,n){
          var selected=n===index;
          tab.classList.toggle('ecom-item-active',selected);
          tab.setAttribute('role','tab');
          tab.setAttribute('aria-selected',selected?'true':'false');
          tab.setAttribute('tabindex',selected?'0':'-1');
          if(panels[n]){
            panels[n].classList.toggle('ecom-item-active',selected);
            panels[n].hidden=!selected;
            panels[n].setAttribute('role','tabpanel');
          }
        });
        if(focus) tabs[index].focus();
      }
      tabs.forEach(function(tab,index){
        var panel=panels[index];
        if(!tab.id) tab.id=(panel&&panel.id?panel.id:'mp-tab-'+index)+'-tab';
        if(panel){
          tab.setAttribute('aria-controls',panel.id);
          panel.setAttribute('aria-labelledby',tab.id);
        }
        tab.addEventListener('click',function(){activate(index,false);});
        tab.addEventListener('keydown',function(event){
          var next=index;
          if(event.key==='ArrowRight') next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft') next=(index+tabs.length-1)%tabs.length;
          else if(event.key==='Home') next=0;
          else if(event.key==='End') next=tabs.length-1;
          else if(event.key==='Enter'||event.key===' '){activate(index,false);event.preventDefault();return;}
          else return;
          event.preventDefault();activate(next,true);
        });
      });
      var initial=Math.max(0,tabs.findIndex(function(tab){return tab.classList.contains('ecom-item-active');}));
      activate(initial,false);
    });
  }
  function init(scope){
    Array.prototype.forEach.call((scope||document).querySelectorAll('[data-mp-native-carousel="true"]'),setupCarousel);
    setupTabs(scope||document);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
}());
